<template>
  <div id="app">
    <router-view  v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
  	return {
  		isRouterAlive:true
  	}
  },
  provide (){
     return {
       reload:this.reload
     }
  },
  created(){
  	this.getsysInfo()
  },
  methods:{
  	async getsysInfo(){
		  	let sysinfo = await this.$ajax.get(this.bUrl + 'api/portal/index/sysinfo');
		  	window.localStorage.setItem("gyzhqy_sys_info",JSON.stringify(sysinfo.data.data))
		},
		reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue